import PropTypes from "prop-types";

export const OrganizationAttributes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  risk_matrix_id: PropTypes.number,
};

export const OrganizationType = PropTypes.shape(OrganizationAttributes);
